<div>
  <app-balance-hud [hudIndex]="hudIndex" />
  <div
    id="balanceLineChart"
    class="balance-line-chart tw-bg-dt-surface-elevated tw-rounded-b-3xl"
  ></div>
</div>
